import { render, staticRenderFns } from "./UserView_Details.vue?vue&type=template&id=6bbc6f5d&scoped=true&"
import script from "./UserView_Details.vue?vue&type=script&lang=js&"
export * from "./UserView_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc6f5d",
  null
  
)

export default component.exports